angular.module("common").directive("epiMenu", function (Menu) {
  return {
    restrict: "A",
    template: require("bundle-text:./views/epi-menu.pug"),
    link: function (scope, _, attr) {
      scope.menuParent = attr.epiMenu === "epi-menu" ? undefined : attr.epiMenu;
    },
  };
});
